import $ from 'jquery';
import AbstractCreditCardGateway from './AbstractCreditCardGateway';

class InlineCreditCardGateway extends AbstractCreditCardGateway {

    selector = '#wc-stripe-card-element';

    elementType = 'card';

    async mountPaymentElement(container) {
        this.paymentElement.mount(container);
        this.paymentElement.update({
            value: {
                postalCode: $('#billing_postcode').val() || ''
            },
            hidePostalCode: $('#billing_postcode').is(':visible')
        })
    }

    buildPaymentElementOptions(isUpdate = false) {
        const options = {
            ...this.settings.inlineFormOptions,
            value: {
                postalCode: $('#billing_postcode').val() || ''
            },
            hidePostalCode: $('#billing_postcode').is(':visible')
        }
        if (isUpdate) {
            delete options.disableLink;
        }
        return options;
    }

    async createPaymentMethod() {
        try {
            const response = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.paymentElement,
                billing_details: this.getBillingDetails()
            });
            if (response.error) {
                throw response.error;
            }
            this.setPaymentMethodId(response.paymentMethod.id);
        } catch (error) {
            throw error;
        }
    }

    async confirmPayment(data, options = {}) {
        return this.stripe.confirmCardPayment(data.client_secret);
    }

    async confirmSetup(data, options = {}) {
        return this.stripe.confirmCardSetup(data.client_secret);
    }
}

export default InlineCreditCardGateway;